import api from "../api/api";
import { GeoCoordinate } from "../interfaces/GeoCoordinate";
import ILocation from "../interfaces/ILocation";
import ILocationInfo from "../interfaces/ILocationInfo";

export default class LocationsApiService {
    public async getLocations(): Promise<ILocation[]> {
        const response = await api.get<ILocation[]>("/location/get");
        return this.mapResponseToLocations(response.data);
    }

    public async createLocation(location: ILocationInfo): Promise<ILocation> {
        const dateSold = location.property.saleDate ? new Date(location.property.saleDate) : undefined;

        const response = await api.post("/location/create", this.mapLocationInfoToUploadModel(location));

        return {
            id: response.data,
            pipedriveCompanyId: location.pipedriveCompanyId,
            regridId: location.regridId,
            centerPoint: location.property.centerPoint,
            siteName: location.siteName,
            address: location.address,
            zoning: location.property.zoning,
            buildingSize: location.property.buildingSize || 0,
            landSize: location.property.landSize || 0,
            ownerName: location.property.ownerEntity!,
            dateSold: dateSold,
            salePrice: location.property.salePrice || 0,
            ownerAddress: location.property.ownerAddress!,
            notes: location.notes,
            createdAt: new Date(),
        };
    }

    public async createLocations(locations: ILocationInfo[]): Promise<void> {
        await api.post("/location/bulkCreate", locations.map(l => this.mapLocationInfoToUploadModel(l)));
    }

    public async updateLocation(location: ILocation): Promise<void> {
        await api.post("/location/update", location);
    }

    public async deleteLocation(id: number): Promise<void> {
        await api.delete(`/location/delete?id=${id}`);
    }

    public async deleteLocations(ids: number[]): Promise<void> {
        await api.delete("/location/bulkDelete", { data: ids });
    }

    private mapResponseToLocations(data: any): ILocation[] {
        return data.map((l: any) => {
            return {
                id: l.id,
                pipedriveCompanyId: l.pipedriveCompanyId,
                regridId: l.regridId,
                centerPoint: new GeoCoordinate(l.latitude, l.longitude),
                siteName: l.siteName,
                address: l.address,
                zoning: l.zoning,
                buildingSize: l.buildingSize,
                landSize: l.landSize,
                ownerName: l.ownerName,
                dateSold: l.dateSold && new Date(l.dateSold),
                salePrice: l.salePrice,
                ownerAddress: l.ownerAddress,
                notes: l.notes,
                createdAt: new Date(l.createdAt),
            } as ILocation;
        });
    }

    private mapLocationInfoToUploadModel(locationInfo: ILocationInfo): any {
        const dateSold = locationInfo.property.saleDate ? new Date(locationInfo.property.saleDate) : undefined;

        return {
            pipedriveCompanyId: locationInfo.pipedriveCompanyId,
            regridId: locationInfo.regridId,
            longitude: locationInfo.property.centerPoint.longitude,
            latitude: locationInfo.property.centerPoint.latitude,
            siteName: locationInfo.siteName,
            address: locationInfo.address,
            zoning: locationInfo.property.zoning,
            buildingSize: locationInfo.property.buildingSize || 0,
            landSize: locationInfo.property.landSize || 0,
            ownerName: locationInfo.property.ownerEntity!,
            dateSold: dateSold,
            salePrice: locationInfo.property.salePrice || 0,
            ownerAddress: locationInfo.property.ownerAddress!,
            notes: locationInfo.notes,
        };
    }
}